import React, { Component } from "react";
import Functions from "../../src/functions";

class Select extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        if (itm !== "didMount") {
          events[itm] = this[itm];
        }
      });
    }

    this.options = [];
    if (this.props.property.configuration) {
      if (this.props.property.configuration.options) {
        this.options = this.props.property.configuration.options;
      }

      if (typeof this.options === "function") {
        this.options = this.props.property.configuration.options;
        this.options = this.options.bind(this);
        this.options = this.options();
      }
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value
        ? this.props.value.toString()
        : defaultValue,
    };
  }

  componentDidMount() {
    this.setState({
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      options: this.options,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "No data",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      setTimeout(this.didMount, 0);
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  editable() {
    let nodata = "";

    if (this.state.options.length < 1) {
      nodata = (
        <option value="" disabled selected>
          {this.state.placeholder}
        </option>
      );
    }

    let control = (
      <select
        defaultValue={this.state.defaultValue}
        name={this.state.name}
        {...this.state.attributes}
        {...this.state.events}
      >
        {nodata}
        {this.state.options.map((item, key) => {
          let selected = "";
          if (
            item.value.toString().toLowerCase() ===
            this.state.defaultValue.toString().toLowerCase()
          ) {
            selected = "selected";
          }

          return (
            <option
              key={key}
              value={item.value}
              item={JSON.stringify(item)}
              selected={selected}
            >
              {item.label}
            </option>
          );
        })}
      </select>
    );

    return this.customUI(control);
  }

  nonEditable() {
    let control = this.state.options.map((item, key) => {
      if (
        item.value.toString().toLowerCase() ===
        this.state.defaultValue.toString().toLowerCase()
      ) {
        return item.label;
      }

      return "";
    });

    return this.customUI(control);
  }

  render() {
    if (this.state.loaded) {
      let control = this.state.editable ? this.editable() : this.nonEditable();

      return control;
    }
    return "";
  }
}

export default Select;
